import ArticleArchive from "./ArticleArchive";
import ArticleFile from "./ArticleFile";
import ArticleHeader from "./ArticleHeader";
import ArticleHighlight from "./ArticleHighlight";
import CookieConsent from "./CookieConsent";
import ExtendedContent from "./ExtendedContent";
import FloatingBar from "./FloatingBar";
import Heading from "./Heading";
import Image from "./Image";
import HTML from "./HTML";
import LanguageSwitcher from "./LanguageSwitcher";
import List from "./List";
import LocationSwitcher from "./LocationSwitcher";
import LocationSwitcherModal from "./LocationSwitcherModal";
import MoreContent from "./MoreContent";
import NotificationBanner from "./NotificationBanner";
import Paragraph from "./Paragraph";
import ProductHighlight from "./ProductHighlight";
import Showcase from "./Showcase";
import Spacer from "./Spacer";
import VideoHero from "./VideoHero";
import VideoThumbnail from "./VideoThumbnail";
import UpdateContactModal from "./UpdateContactModal";

export default {
  ArticleArchive,
  ArticleFile,
  ArticleHeader,
  ArticleHighlight,
  CookieConsent,
  ExtendedContent,
  FloatingBar,
  Heading,
  HTML,
  Image,
  LanguageSwitcher,
  List,
  LocationSwitcher,
  LocationSwitcherModal,
  MoreContent,
  NotificationBanner,
  Paragraph,
  ProductHighlight,
  Showcase,
  Spacer,
  UpdateContactModal,
  VideoHero,
  VideoThumbnail,
};
